import { urlBuilder } from '@/connectors/endpoints'
import { arrayMapper } from '@/mappers'
import { employeesMap } from '@/mappers/employees'
import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { IEmployee } from '@/types/employees'

const getEmployees = (moid: number, endPoint: string) => {
  return new AxiosRequestBuilder<IEmployee[]>({
    url: urlBuilder(endPoint, String(moid)),
    method: 'get',
    responseMapperFunction: arrayMapper,
    responseMapper: employeesMap
  }).exec().then((response) => response.data)
}

export default getEmployees
